// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"faef145b","353":"2eeecc53"}[chunkId] + ".js";
};